module.exports = __webpack_public_path__ + "static/media/Colizeum_main_preview.2a78cc29.jpg";